import Utils from '../../modules/utils'

const getTicketInfo = (callback) => {
  Utils.get('ticket_info', (err, res) => {
    if (err) { return }
    callback(res.data || {})
  })
}

export {getTicketInfo}
